import {
  ProductState,
  ProductStateStatus,
  SubscriptionActivationLimitTrigger,
} from 'protocol/api/billing_new/dto_product_new_pb';

import {
  getSubscriptionEndMillis,
  getSubscriptionStartMillis,
} from './subscriptionDate';

export const isCurrentSubscription = (
  subscription: ProductState,
  now = Date.now(),
): boolean => {
  const start = getSubscriptionStartMillis(subscription);
  const end = getSubscriptionEndMillis(subscription);

  // The Active check is what keeps a limit-scheduled subscription out: it has
  // Start and End both zero, which would otherwise read as a lifetime product
  // that started at the epoch.
  return (
    subscription.Status === ProductStateStatus.ProductStateStatusActive &&
    start <= now &&
    (end === 0 || now < end)
  );
};

// A subscription queued behind the current one by limit exhaustion. It waits as
// AwaitingActivation with no dates, because its period is only known once the
// trigger fires.
//
// The trigger check is deliberate: matching bare AwaitingActivation would also
// pull in legacy manual-activation subscriptions, which are a different feature.
export const isLimitScheduledSubscription = (
  subscription: ProductState,
): boolean =>
  subscription.Status ===
    ProductStateStatus.ProductStateStatusAwaitingActivation &&
  subscription.ActivateOnLimitTrigger !==
    SubscriptionActivationLimitTrigger.SubscriptionActivationLimitTriggerInvalidValue;

export const isScheduledSubscription = (
  subscription: ProductState,
  now = Date.now(),
): boolean =>
  isLimitScheduledSubscription(subscription) ||
  (subscription.Status === ProductStateStatus.ProductStateStatusActive &&
    getSubscriptionStartMillis(subscription) > now);
